<template>
	<div>
		<b-row align-h="end" style="margin-top:20px;">
			<b-col cols="1">
				<b-form-select v-model="filter.size" class="sm">
					<option value="10">10</option>
					<option value="20">20</option>
					<option value="30">30</option>
				</b-form-select>
			</b-col>
			<b-col>
				<b-pagination v-model="filter.page" :total-rows="page.totalElements"
					:per-page="page.size"></b-pagination>
			</b-col>
			<b-col>
			</b-col>
			<b-col cols="4">
				<b-input-group>
					<b-form-input v-model="tableFilter" type="search" id="filterInput"
						placeholder="Buscar na página..."></b-form-input>
				</b-input-group>
			</b-col>
		</b-row>

		<slot name="content" model="content"></slot>

		<b-row v-if="page">
      <b-col>
        <div>Mostrando {{page.numberOfElements}} de um total de {{page.totalElements}} registros</div>
      </b-col>
    </b-row>
	</div>
</template>
<script>
export default {
	props: ['filter', 'tableFilter', 'page'],
	data() {
		return {

		}
	},
	methods: {
		fetchModels() {
			this.$emit('fetchServiceOrders', this.filter)
		}
	},
	watch: {
    'filter.page': {
      handler() {
        this.fetchModels();
      }
    },
    'filter.size': {
      handler() {
        this.fetchModels();
      }
    },

  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/shared/BaseHeadListingPage.vue